import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import ConfirmProvider from "./components/ConfirmProvider.jsx";

const root = createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    {/* Inside the boundary so a crash still renders the fallback, but ABOVE App so every
        component can call useConfirm() — it replaces window.confirm app-wide. */}
    <ConfirmProvider>
      <App />
    </ConfirmProvider>
  </ErrorBoundary>
);

// src/index.jsx (near startup)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" })
      .catch((err) => console.error("SW registration failed:", err));
  });
}


